import { useState, useEffect } from 'react';
import { useAuth } from '@orbit/shared/auth';
import { getNextTasks, NextTaskInfo } from '@orbit/shared/business-ideas';
import { useBusinessIdea } from './useBusinessIdea';

export const useNextTasks = (limit: number = 5) => {
  const { user } = useAuth();
  const { businessIdea, loading: businessIdeaLoading } = useBusinessIdea();
  const [nextTasks, setNextTasks] = useState<NextTaskInfo[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const calculateNextTasks = () => {
      if (!user || !businessIdea?.id || businessIdeaLoading) {
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Use client-side version that works with already-fetched data
        const nextTasksData = getNextTasks(businessIdea, user.id, limit);
        setNextTasks(nextTasksData);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to calculate next tasks');
      } finally {
        setLoading(false);
      }
    };

    calculateNextTasks();
  }, [user, businessIdea, businessIdeaLoading, limit]);

  return {
    nextTasks,
    loading,
    error,
  };
};
